"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactApollo = require("react-apollo");

var _lib = require("../../lib");

var _common = require("../../common");

var _context = _interopRequireDefault(require("./context"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

var APIProvider = function APIProvider(_ref) {
  var name = _ref.name,
      selector = _ref.selector,
      children = _ref.children;

  var _useContext = (0, _react.useContext)(_context.default),
      clients = _useContext.clients;

  var client = (0, _lib.getSelectorValue)(clients, name || selector);

  if (!client) {
    console.warn("".concat(name || selector, " not found in context provided: ").concat(clients));
  }

  return _react.default.createElement(_reactApollo.ApolloProvider, {
    client: client
  }, children);
};

APIProvider.propTypes = {
  name: _propTypes.default.string,
  selector: _common.customPropTypes.as,
  children: _propTypes.default.node
};
APIProvider.defaultProps = {
  name: null,
  selector: null,
  children: null
};
var _default = APIProvider;
exports.default = _default;